import getDateObjectFrom from './get-date-object-from';

const calculateHoursDifference = (firstDate, secondDate) => {
  const dayOne = getDateObjectFrom(firstDate);
  const dayTwo = getDateObjectFrom(secondDate);

  if (!Date.parse(dayOne) || !Date.parse(dayTwo)) return 0;

  const oneHour = 60 * 60 * 1000;

  return Math.floor(Math.abs((dayOne - dayTwo) / oneHour));
};

export default calculateHoursDifference;
